import withSelectRateOfCountryToSend from 'components/Dashboard/HOCs/withSelectRateOfCountryToSend';
import ButtonCommon from 'components/common/ButtonCommon';
import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import styled from 'styled-components';
import ExchangeRateItem from '../../ExchangeRateItem/ver3';

const SelectRateOfCountryToSendButton =
  withSelectRateOfCountryToSend(ButtonCommon);

const ExchangeRateSection = ({ remittanceRatesData, countries }) => {
  const { t } = useLang();
  const [current, setCurrent] = useState(0);

  const getCountryNameByCode = (countryCode) => {
    if (isEmpty(countries)) return null;
    const country = countries.find((country) => country.code === countryCode);
    return country ? country.name : '';
  };

  if (isEmpty(remittanceRatesData)) {
    return null;
  }
  return (
    <Wrapper>
      <RatesWrap>
        {Object.keys(remittanceRatesData).map((country, index) => (
          <ExchangeRateItem
            key={country}
            country={country}
            countryName={getCountryNameByCode(country)}
            rates={remittanceRatesData[country]}
            isActive={index === current}
            onClick={() => setCurrent(index)}
          />
        ))}
      </RatesWrap>
      <SelectRateOfCountryToSendButton
        value={t('label_other_countries')}
        styles={{
          margin: '0px',
          marginTop: '24px',
          paddingInline: '40px',
          width: 'fit-content',
          height: '40px',
          border: '1px solid #000',
          borderRadius: '100px',
          fontWeight: 500,
        }}
        background="var(--ds-c-white)"
        isFill={false}
        remittanceRatesData={remittanceRatesData}
        countries={countries}
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  height: fit-content;

  font-family: var(--ff-primary);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: var(--ds-c-black);

  padding-bottom: 0px;

  & b {
    color: var(--ds-c-red);
  }
`;

const RatesWrap = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 10px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    gap: 20px;
    margin-bottom: 0px;
  }
`;

export default ExchangeRateSection;
